import axios from "axios";
import {useEffect, useState} from 'react';
import config from "../config";

const MatchesDisplay = ({own_matches, setClickedClothes}) => {
    const [clothes, setClothes] = useState([])
    const getMatchedClothes = async (matchedClothesIds) => {   
        try {
            const response = await axios.get(`${config.apiUrl}clothes`, {
                headers: {"token": localStorage.getItem("token")},
                params: {clothesIds: matchedClothesIds}
            })
            setClothes(response.data)
        } catch (error) {
            console.log(error)
        }
        
    }
    useEffect(() => {
        getMatchedClothes(own_matches);
    }, [own_matches]);

    return(
        <div className="matches-display">
            {clothes?.map((match, _index) => (
                <div
                    key={_index}
                    className="match-card"
                    onClick={() => setClickedClothes(match)
                    }
                >
                    <div className="img-container">
                        <img src={match?.url} alt={match?.clothing_type + " profile"} />
                    </div>
                </div>
            ))}
        </div>
    )
}
export default MatchesDisplay